import type { FC, ReactNode } from 'react'

import { band, navSections } from '@/constants/portfolio'
import { scrollToSection } from '@/lib/scroll-to'
import CrestMark from '@/components/landing/crest-mark'

const SiteFooter: FC = (): ReactNode => (
    <footer className='relative bg-ink text-paper' data-theme='night'>
        <div className='mx-auto grid max-w-[1680px] gap-12 px-5 py-16 xs:px-8 tab:grid-cols-[auto_1fr_auto] tab:items-start tab:px-12 tab:py-20'>
            <CrestMark className='size-24 tab:size-28' />

            <div>
                <p className='display-type text-[clamp(2.2rem,5vw,4.4rem)] leading-[0.9]'>
                    {band.tagline.map(line => (
                        <span key={line} className='block'>{line}</span>
                    ))}
                </p>
                <p className='mt-6 max-w-[52ch] text-[15px] leading-[1.6] text-paper/75'>
                    {band.summary} Follow the band for new songs, shows and news.
                </p>
            </div>

            <nav aria-label='Footer' className='flex flex-col gap-6'>
                <ul className='flex flex-col gap-2'>
                    {navSections.map(section => (
                        <li key={section.id}>
                            <a
                                href={`#${section.id}`}
                                onClick={event => {
                                    event.preventDefault()
                                    scrollToSection(section.id)
                                }}
                                className='text-[15px] font-semibold text-paper/85 underline-offset-4 hover:text-paper hover:underline'
                            >
                                {section.label}
                            </a>
                        </li>
                    ))}
                </ul>

                <a
                    href={band.socialLinks.instagram}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='mono-label text-xs text-paper underline underline-offset-4'
                >
                    Instagram {band.socialLinks.instagramHandle}
                    <span className='sr-only'> (opens in a new tab)</span>
                </a>
            </nav>
        </div>

        <div className='border-t border-paper/15'>
            <div className='mx-auto flex max-w-[1680px] flex-col gap-3 px-5 py-6 xs:px-8 tab:flex-row tab:items-center tab:justify-between tab:px-12'>
                <p className='mono-label text-[10px] text-paper/60'>
                    © 2026 {band.name}. All rights reserved.
                </p>
                <p className='mono-label text-[10px] text-paper/60'>
                    Audio on this page is a placeholder preview until the band&apos;s recordings are added.
                </p>
                <a
                    href='#top'
                    onClick={event => {
                        event.preventDefault()
                        scrollToSection('top')
                    }}
                    className='mono-label text-[10px] text-paper underline underline-offset-4'
                >
                    Back to top
                </a>
            </div>
        </div>
    </footer>
)

export default SiteFooter
